export default {
  en: {
    title: 'Summary',
    messages: 'Messages',
    words: 'Words said',
    time: 'Practice time',
    minutesValue_one: '{{count}} min',
    minutesValue_other: '{{count}} min',
    accuracy: 'Correct speech',
    mistakesTitle: 'Mistakes',
    noMistakes: 'Not a single mistake in this conversation.',
    deleteMistakeAria: 'Delete the mistake “{{original}}”',
    improvementsTitle: 'In other words',
    learnedTitle: 'What I learned about you',
    forgetFact: 'Forget this',
    learnedLoading: 'Remembering the conversation',
    learnedNothing: 'Nothing new this time — tell me more about yourself next time.',
    done: 'Done',
  },
  ru: {
    title: 'Итоги',
    messages: 'Реплик',
    words: 'Слов сказано',
    time: 'Время практики',
    minutesValue_one: '{{count}} мин',
    minutesValue_few: '{{count}} мин',
    minutesValue_many: '{{count}} мин',
    minutesValue_other: '{{count}} мин',
    accuracy: 'Правильной речи',
    mistakesTitle: 'Ошибки',
    noMistakes: 'В этом разговоре — ни одной ошибки.',
    deleteMistakeAria: 'Удалить ошибку «{{original}}»',
    improvementsTitle: 'Другими словами',
    learnedTitle: 'Что я о тебе узнал',
    forgetFact: 'Забыть это',
    learnedLoading: 'Запоминаю разговор',
    learnedNothing: 'В этот раз ничего нового — расскажи о себе побольше в следующий раз.',
    done: 'Готово',
  },
};
